/*
 * @Descripttion: 仅做展示的表单控件
 * @Author: renbh
 * @Date: 2023-04-17 14:34:53
 * @LastEditors: renbh
 * @LastEditTime: 2023-05-10 15:27:54
 */

import React from 'react'

interface Props
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  > {
  value?: any
  formatValue?: (val?: any) => any
  suffix?: string
}

const ShowOnlyFormControl: React.FC<Props> = (props) => {
  const { value, formatValue = (val) => val, suffix, ...restProps } = props

  return (
    <span title={formatValue(value)} {...restProps}>
      {formatValue(value)}
      {suffix}
    </span>
  )
}

export default ShowOnlyFormControl
/*
 * @Descripttion: 仅做展示的表单控件
 * @Author: renbh
 * @Date: 2023-04-17 14:34:53
 * @LastEditors: renbh
 * @LastEditTime: 2023-05-10 15:27:54
 */

import React from 'react'

interface Props
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  > {
  value?: any
  formatValue?: (val?: any) => any
  suffix?: string
}

const ShowOnlyFormControl: React.FC<Props> = (props) => {
  const { value, formatValue = (val) => val, suffix, ...restProps } = props

  return (
    <span title={formatValue(value)} {...restProps}>
      {formatValue(value)}
      {suffix}
    </span>
  )
}

export default ShowOnlyFormControl
